<script lang="ts">
  import type { LucideIcon } from "@lucide/svelte";
  import ArrowLeftRightIcon from "@lucide/svelte/icons/arrow-left-right";
  import ArrowUpDownIcon from "@lucide/svelte/icons/arrow-up-down";
  import CornerDownLeftIcon from "@lucide/svelte/icons/corner-down-left";
  import clsx from "clsx";

  type Props = {
    /** Show the ⇄ "Change tabs" hint, e.g. while a tabbed sub-mode is open. */
    showChangeTabs?: boolean;
  };

  let { showChangeTabs = false }: Props = $props();

  const KBD_BASE = "bg-secondary text-secondary inline-flex rounded";
</script>

{#snippet shortcut(Icon: LucideIcon, label: string)}
  <div class="flex items-center gap-1.5">
    <kbd class={clsx(KBD_BASE, "h-5 w-5 items-center justify-center")}>
      <Icon size={12} class="icon-secondary" />
    </kbd>
    <span class="text-secondary">{label}</span>
  </div>
{/snippet}

<div
  class="flex items-center gap-5 border-t border-secondary px-4 py-2.5 text-xs"
>
  {@render shortcut(CornerDownLeftIcon, "Open")}
  {@render shortcut(ArrowUpDownIcon, "Select")}
  {#if showChangeTabs}
    {@render shortcut(ArrowLeftRightIcon, "Change tabs")}
  {/if}
  <div class="flex items-center gap-1.5">
    <!-- TODO(jordan): break kbd icon into shared component with SearchInput -->
    <kbd
      class={clsx(
        KBD_BASE,
        "h-5 items-center justify-center px-1.5 py-0.5 text-xs icon-secondary",
      )}>esc</kbd
    >
    <span class="text-secondary">Close</span>
  </div>
</div>
